import { startScrollTracking } from "./scroll.js";
import { startRageClickTracking } from "./rageClicks.js";

export interface TrackingExtrasOptions {
  /** Fire a 'scroll' event each time the user crosses a 25/50/75/100% depth milestone. */
  scroll?: boolean;
  /** Fire a 'rage_click' event when ≥3 clicks on the same target occur within a 1-second window. */
  rageClicks?: boolean;
}

type Push = (name: string, properties?: Record<string, unknown>) => void;

export function startTrackingExtras(options: TrackingExtrasOptions, push: Push): () => void {
  const disposers: Array<() => void> = [];

  if (options.scroll) {
    disposers.push(startScrollTracking(push));
  }
  if (options.rageClicks) {
    disposers.push(startRageClickTracking(push));
  }

  return () => {
    for (const dispose of disposers) dispose();
    disposers.length = 0;
  };
}
